import {
  createPortalToolPayloadFormatter,
  type PortalToolName,
} from '@terra/shared-dto-chat-types';
import type { PayloadFormatter } from '../shared/types';

export function createPortalToolPayloadFormatterForConfig(
  toolName: PortalToolName,
): PayloadFormatter {
  const formatter = createPortalToolPayloadFormatter(toolName);
  return (args) => formatter(args);
}
